import { defineFeature } from "../core/composition/define-feature.js";
import { trackCurrentTime } from "../behaviors/dom/track-current-time.js";
//#region src/playback/features/current-time.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [trackCurrentTime];
/** The config defaults the feature contributes. */
const defaultConfig = {};
/** The state values the feature seeds. */
const initialState = {};
/** Mirrors the media element's `currentTime` into state, which segment loading reads to plan what to load next. */
const currentTimeFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, currentTimeFeature, defaultConfig, initialState };
